<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Pancreas Specific Details EMR-Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="pancreasType"
              disabled
              label="PAK"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="diabetesTypeCode"
              disabled
              label="Diabetes Type Code"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="comments"
              disabled
              label="Comments"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "PancreasSpecificSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      pancreasType: this.getPancreasType( this.patientBundle ),
      diabetesTypeCode: this.getDiabetesTypeCode( this.patientBundle ),
      comments: this.getComments( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getPancreasType( patientBundle ) {
      if( this.getSmartdataComponentValue( patientBundle, 'SK#8198', 'valueBoolean' ) == null || this.getSmartdataComponentValue( patientBundle, 'SK#8198', 'valueBoolean' ) === '' ) 
      return 'Unchecked';
      return this.getSmartdataComponentValue( patientBundle, 'SK#8198', 'valueBoolean' ) === true ? 'Checked' : 'Unchecked';
    },
    getDiabetesTypeCode( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8199' );
    },
    getComments( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8200' );
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 250px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
